import { Box, Card, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../contexts/AuthContext';
import { useUsers } from '../../hooks/api/useUsers';
import { AdminsTable } from './components/AdminsTable';
import { AlertToast } from '../../components/AlertToast';
import { PageTitle } from '../../components/PageTitle';
import { AddAdminDialog } from './components/AddAdminDialog';

export const AdminManagement = () => {
  const { impersonationLock } = useAuthContext();
  const [deleteAlert, setDeleteAlert] = useState(false);

  const { users, deleteUser } = useUsers();

  useEffect(() => {
    if (!deleteAlert) return;
    const timer = setTimeout(() => {
      setDeleteAlert(false);
    }, 1600);

    return () => clearTimeout(timer);
  }, [deleteAlert]);

  const onDeleteUserHandler = async (email: string) => {
    await deleteUser(email);
    setDeleteAlert(true);
  };

  const { t } = useTranslation();

  return (
    <>
      <PageTitle title="Admin Management" />
      {deleteAlert && (
        <AlertToast severity="success">
          User has been deleted successfully!
        </AlertToast>
      )}
      <Card
        variant="default"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 3,
        }}
      >
        <Box>
          <Typography component="h1" variant="h4" gutterBottom>
            {t('home.userManagementTitle')}
          </Typography>
          <Typography variant="body1">
            Manage your JST admins including adding or removing accounts
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column' },
            gap: 10,
            mt: { xs: 10, md: 0 },
          }}
        >
          <AddAdminDialog text="Add Admin" disabled={impersonationLock} />
        </Box>
      </Card>
      <AdminsTable
        users={users}
        impersonationLock={impersonationLock}
        onDeleteUser={onDeleteUserHandler}
      />
    </>
  );
};
